<template>
  <v-card width="auto" elevation="0">
    <v-form ref="form">
      <v-card-text>
        <v-row dense>
          <v-col v-for="(field, i) in form" :key="i" :cols="field.cols" :offset="field.offset" :hidden="field.hidden">
            <p v-if="field.field == 'viewText' && !field.hidden">
              <label class="font-weight-bold">{{field.name}} </label> {{model[field.nameid]}}
            </p>

            <p v-if="field.field == 'viewTextList' && !field.hidden">
              <label class="font-weight-bold">{{field.name}} </label>
              <v-chip v-for="(item, index) in model[field.nameid]" :key="index"
                :color="field.color" class="ma-1" small label outlined>
              <span class="font-weight-bold text-uppercase">{{item[field.itemnameid]}}</span>
            </v-chip>
            </p>

            <v-text-field
              v-if="field.field == 'text' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :type="field.type"
              :rules="field.rules ? fieldRequired : []"
              outlined
              dense>
            </v-text-field>

            <v-text-field
              v-if="field.field == 'number' && !field.hidden"
              v-model.number="model[field.nameid]"
              :label="field.name"
              :type="field.type"
              min="0"
              :rules="field.rules ? fieldRequired : []"
              outlined
              dense>
            </v-text-field>

            <v-textarea
              v-else-if="field.field == 'textArea' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :name="field.dimens"
              :rules="field.rules ? fieldRequired : []"
              outlined
              dense>
            </v-textarea>

            <v-select
              v-else-if="field.field == 'select' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :items="field.items"
              :rules="field.rules ? fieldRequired : []"
              outlined
              dense
            >
            </v-select>

            <div v-else-if="field.field == 'radioButton' && !field.hidden">
              <label class="black--text font-weight-bold font-weight-black subtitle-2">{{ field.name }}</label>
              <v-radio-group
                v-model="model[field.nameid]"
                :row="field.row"
                :rules="field.rules ? fieldRequired : []"
                class="pa-0 ma-0"
                @change="RadioButtonEvent(field)">
                <v-radio
                  v-for="value in field.items"
                  :key="value"
                  :label="value"
                  :value="value">
                </v-radio>
              </v-radio-group>
            </div>

            <div v-else-if="field.field == 'checkbox'">
              <p class="ma-0 pa-0 text--black font-weight-bold font-weight-black subtitle-2"> {{ field.name }} </p>
              <v-checkbox
                v-for="value in field.items"
                :key="value"
                :class="field.row ? 'mr-3 pa-0 checkbook-horizontal' : 'ma-0 pa-0'"
                v-model="model[field.nameid]"
                :label="value"
                :value="value"
                :rules="field.rules ? fieldRequired : []">
              </v-checkbox>
            </div>

            <SearchDinamicField
              v-else-if="field.field == 'searchDataServer' && !field.hidden"
              :setterModel="model"
              :itemAction="field"
              :on-success="actionFieldData"
            />

            <DatePicker
              v-else-if="field.field == 'textDatePicker' && !field.hidden"
              :itemAction="field"
              :on-success="actionFieldData"
            />
            <TimePicker
              v-else-if="field.field == 'textTimePicker' && !field.hidden"
              :itemAction="field"
              :on-success="actionFieldData"
            />

            <SelectedDinamicField
              v-else-if="field.field == 'selectDataServer' && !field.hidden"
              :setterModel="model[field.nameid]"
              :itemAction="field"
              :on-success="actionFieldData"
            />

            <SelectedGroupDinamicField
              v-else-if="field.field == 'selectGroupDataServer' && !field.hidden"
              :setterModel="model[field.nameid]"
              :itemAction="field"
              :on-success="actionFieldData"
            />

            <FileInputDinamicField v-else-if="field.field == 'fileInputDataServer' && !field.hidden"
              :itemAction="field"
              :on-success="actionFieldData"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
    <v-card-actions class="mx-2">
      <!-- <v-btn color="light-green darken-2" depressed outlined>Limpiar</v-btn> -->
      <v-spacer></v-spacer>
      <v-btn @click="onCancel" color="red darken-2" depressed outlined>Cerrar</v-btn>
      <v-btn @click="sendForm" color="success darken-1" depressed outlined >Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import DatePicker from '@/components/fields/DatePicker'
import TimePicker from '@/components/fields/TimePicker'
import SearchDinamicField from '@/components/fields/SearchDinamicField'
import SelectedDinamicField from '@/components/fields/SelectedDinamicField'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import FileInputDinamicField from '@/components/fields/FileInputDinamicField'

export default {
  name: 'MainProcessForm',
  props: ['form', 'model', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
    selected: [],
    indice: ''
  }),
  components: {
    DatePicker,
    TimePicker,
    SearchDinamicField,
    SelectedDinamicField,
    SelectedGroupDinamicField,
    FileInputDinamicField
  },
  methods: {
    ...mapActions(['postServiceActionRemoveRol']),
    RadioButtonEvent (item) {
      if (item.action) {
        this[item.action](item)
      }
    },
    ShowTipoPlaza (field) {
      const response = this.model[field.nameid]
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (response === 'NO') {
                form.hidden = false
                this.model[form.nameid] = ''
                return
              }
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },

    checkboxEvent (item) {},

    actionFieldData (obj) {
      this.model[obj.id] = (obj.data) ? obj.data : null
      this.actionDinamicData(obj)
    },
    actionDinamicData (obj) {
      if (obj.action) {
        this[obj.action](obj)
      }
    },
    removeRole (obj) {
    },

    findBillEmployee ({ id, data, field }) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.map((form, index) => {
            if (item === form.nameid) {
              if (form.hidden) {
                form.params[id] = data
                form.hidden = false
              }
            }
          })
        })
      }
    },
    sendForm () {
      if (this.$refs.form.validate()) {
        const item = this.validateComponents()
        if (item !== null) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Advertencia!',
            text: ' Campo ' + item.name + ' no debe ser vacio!!'
          })
          return
        }
        this.onSuccess(this.model)
      }
    },
    validateComponents () {
      let itemSelected = null
      this.form.map(item => {
        if (item.rules) {
          if (!item.hidden) {
            if (!this.model[item.nameid]) {
              itemSelected = item
            } else if (this.model[item.nameid] === null) {
              itemSelected = item
            }
          }
        }
      })
      return itemSelected
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
  }
}
</script>

<style>
.box-color-red {
  border: 1px red solid;
}
div .checkbook-horizontal {
  display: inline-block;
}
</style>
